import clsx from "clsx"
import React from "react"


export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className, ...props }, ref) => {
        return (
            <div
                className={clsx('bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden', className)}
                ref={ref}
                {...props}
            />
        )
    }
)

Card.displayName = 'Card'
